// React
import React, { useState, useEffect, useContext, useRef } from "react";
// React
// CSS
import styles from "./Teacher.module.css";
// CSS
// Services
import { getTeacherTeachItemsService } from "../../Services/Teachers/get/getTeacherTeachItemsService";
// Services
// Modules
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
// Modules
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Components
import LessonStatus from "./LessonStatus/LessonStatus";
import LessonCard from "./LessonCard/LessonCard";
import PendingManager from "../../Components/PendingManager/PendingManager";
// Components
// Models
import {I_UserLessonSubject} from "../../Models/interfaces";
// Models
// Contexts
import { SetLessonDataContext } from "../../Contexts/SetLessonDataContext";
// Contexts
// Images
import { nodata, vidolist_watermark } from "../../Images/images";
import { _parser } from "../../Utils/_parser";
import { localStorageAvailabilityChecker } from "../../Utils/localStorageAvailabilityChecker";
import { SetAllDataNeededContext } from "../../Contexts/AllDataNeededContext";
// Images

const Teacher = () => {
  // States
  const [lessonSubjects, setLessonSubjects] = useState<I_UserLessonSubject[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);
  // States
  // Constants
  const { teacherId } = useParams();
  const userToken = useContext(UserTokenContext);
  const { state } = useLocation();
  const navigate = useNavigate();
  const setLessonData = useContext(SetLessonDataContext);
  const setAllNeededData = useContext(SetAllDataNeededContext);
  // Constants
  // refs

  const teacherIdRef = useRef<string | number | null>(
    _parser(localStorage.getItem("teacherId"))
  );
  // refs
  // LifeCycles
  useEffect(() => {
    if (!state || !state.teacherData) {
      navigate("/");
      return;
    } else {
      if (!setLessonData) return;
      if (!teacherIdRef.current) return;
      setLessonData((prevState) => ({
        ...prevState,
        teacherId: String(teacherIdRef.current || teacherId),
      }));
    }
  }, [navigate, state, setLessonData, teacherIdRef, teacherId]);
  //
  useEffect(() => {
    if (!state.teacherData) return;
    setLessonSubjects(state.teacherData.subjects);
    setIsPending(false);
  }, [userToken, teacherIdRef, teacherId]);
  //
  useEffect(() => {
    if (!state || !state.teacherData) {
      navigate("/");
      return;
    } else {
      const isLocalStorageAvailable = localStorageAvailabilityChecker();

      if (isLocalStorageAvailable) {
        if (!setLessonData) return;
        setLessonData((prevState) => {
          return {
            ...prevState,
            lessonId: _parser(localStorage.getItem("lessonId")),
            lessonName: String(
              _parser(localStorage.getItem("lessonData")).title
            ),
          };
        });
      }

      setAllNeededData((prevState) => ({
        ...prevState,
        teacherId: String(teacherId),
        teacherName: String(state.teacherName),
      }));
    }
  }, [setLessonData, setAllNeededData, state, teacherId, navigate]);
  // LifeCycles

  if (!state || !state.teacherData) {
    navigate("/");
    return <></>;
  }

  return (
    <div className={`${styles.teacherContainer} p-4 relative`}>
      <LessonStatus
        customData={state.title}
        imageUrl={String(state.url)}
        teacherName={state.teacherData.fullName}
      />
      <div
        className={`${styles.lessonsContainer} px-4 mt-4 bg-white rounded-xl overflow-y-scroll relative flex items-center flex-col `}
      >
        <div className="relative z-20 w-full">
          <PendingManager
            data={
              <>
                {lessonSubjects.length === 0 ? (
                  <img
                    src={nodata}
                    alt="nodataImg"
                    style={{
                      margin: "0 auto",
                    }}
                  />
                ) : (
                    lessonSubjects.map((item) => (
                    <LessonCard
                      key={item.id}
                      data={item}
                      state={state}
                      teacherName={state.teacherData.fullName}
                    />
                  ))
                )}
              </>
            }
            isPending={isPending}
          />
        </div>
        <img
          src={vidolist_watermark}
          className="w-10/12 opacity-40 fixed z-10 "
          alt=""
          style={{
            bottom: "10vh",
            width: window.innerWidth > 600 ? "590px" : "83%",
          }}
        />
      </div>
    </div>
  );
};

export default Teacher;
